import * as React from 'react'

const SvgProIcon = (props) => (
  <svg
    width="37"
    height="36"
    viewBox="0 0 37 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="2.66602" y="2" width="32" height="32" rx="16" fill="#FFF4ED" />
    <g clipPath="url(#clip0_3049_80194)">
      <path
        d="M14 16.6667V20.6741C14 20.9134 14 21.0331 14.0364 21.1387C14.0687 21.2321 14.1212 21.3172 14.1904 21.3878C14.2686 21.4676 14.3756 21.5211 14.5896 21.6282L18.1896 23.4282C18.3645 23.5156 18.452 23.5593 18.5437 23.5765C18.625 23.5918 18.7084 23.5918 18.7896 23.5765C18.8813 23.5593 18.9688 23.5156 19.1437 23.4282L22.7437 21.6282C22.9577 21.5211 23.0648 21.4676 23.1429 21.3878C23.2121 21.3172 23.2647 21.2321 23.2969 21.1387C23.3333 21.0331 23.3333 20.9134 23.3333 20.6741V16.6667M12 15.6667L18.4282 12.4526C18.5156 12.4089 18.5593 12.387 18.6052 12.3784C18.6458 12.3708 18.6875 12.3708 18.7281 12.3784C18.774 12.387 18.8177 12.4089 18.9052 12.4526L25.3333 15.6667L18.9052 18.8807C18.8177 18.9245 18.774 18.9463 18.7281 18.9549C18.6875 18.9626 18.6458 18.9626 18.6052 18.9549C18.5593 18.9463 18.5156 18.9245 18.4282 18.8807L12 15.6667Z"
        stroke="#FF692E"
        strokeWidth="1.67"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <rect
      x="2.66602"
      y="2"
      width="32"
      height="32"
      rx="16"
      stroke="#FFE6D5"
      strokeWidth="4"
    />
    <defs>
      <clipPath id="clip0_3049_80194">
        <rect
          width="16"
          height="16"
          fill="white"
          transform="translate(10.666 10)"
        />
      </clipPath>
    </defs>
  </svg>
)

export default SvgProIcon
